import { getShuttersClipPaths, getEasing, toKeyframeValue } from '../../utils';
export function getNames(_) {
  return ['shuttersIn'];
}
export function web(options) {
  return style(options, true);
}
export function style(options, asWeb) {
  if (asWeb === void 0) {
    asWeb = false;
  }
  const {
    direction = 'right',
    shutters = 12,
    staggered = true
  } = options.namedEffect;
  const [shuttersIn] = getNames(options);
  const {
    clipStart,
    clipEnd
  } = getShuttersClipPaths(direction, shutters, staggered);
  const custom = {
    '--motion-shutters-start': clipStart,
    '--motion-shutters-end': clipEnd
  };
  const easing = getEasing(options.easing || 'sineIn');
  return [{
    ...options,
    easing,
    name: shuttersIn,
    custom,
    keyframes: [{
      clipPath: toKeyframeValue(custom, '--motion-shutters-start', asWeb)
    }, {
      clipPath: toKeyframeValue(custom, '--motion-shutters-end', asWeb)
    }]
  }];
}
//# sourceMappingURL=ShuttersIn.js.map